import { render } from 'react-dom';
// @ts-ignore
import App from '@picsart/miniapp-editor';
import '@picsart/miniapp-editor/index.css';

render(
  <App />,
  document.getElementById('root') as HTMLElement
);
